
export const ACTIVITY_TYPE = 22;
export const STATUS_COMPLETE = 'COMPLETE'; 
export const AUTO_REFRESH_INTERVAL = 30;
export const NO_CAR = "https://smartexpressblob.blob.core.windows.net/carpadblob/1700233222652Fo.png";


